import React from "react";
import { Loader2 } from "lucide-react";

export function LoadingState({ label = "Caricamento in corso..." }) {
    return (
        <div
            data-testid="loading-state"
            className="flex flex-col items-center justify-center py-16 text-[#64748B]"
        >
            <Loader2 className="w-8 h-8 animate-spin text-[#2563EB]" />
            <p className="mt-3 text-sm">{label}</p>
        </div>
    );
}

export default LoadingState;
